//@ts-nocheck
//@ts-nocheck
import { AddIcon, ArrowBackIcon, DeleteIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  HStack,
  Icon,
  Input,
  Stack,
  Text,
} from "@chakra-ui/react";
import { FieldArray, Form, Formik } from "formik";
import { observer } from "mobx-react-lite";
import React from "react";
import { array, object } from "yup";
import { SingleFormButton } from "./FormButtons";

const RequirementsForm: React.FC<{
  initialValues: { teachingRequirements: string[] };
  onBackClick: () => void;
  isLoading?: boolean;
  subject?: string;
  onSubmit: (values: any) => Promise<any>;
}> = observer(
  ({ onBackClick, initialValues, subject, isLoading, onSubmit }) => {
    const validationSchema = object().shape({
      teachingRequirements: array().required(
        "Add your teaching requirements for this subject",
      ),
    });

    return (
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({ handleSubmit }) => (
          <Box className="teaching-requirements">
            <Button
              mb={6}
              onClick={onBackClick}
              leftIcon={<ArrowBackIcon />}
              variant="link"
              colorScheme="blue"
            >
              Back
            </Button>

            <Stack pb={6}>
              <Text
                fontSize="3xl"
                lineHeight="shorter"
                fontWeight="bold"
                as="h1"
              >
                Add lesson requirements
              </Text>
              <Text mt={1} color="gray.700">
                If there are specific things clients should provide as part of
                the lessons, you may add them - one per line. This is optional,
                and can include such things instruments, specific texts,
                devices, calculator etc.
              </Text>
            </Stack>

            <Form>
              <Box mb={8} pb={20}>
                <FieldArray name="teachingRequirements">
                  {({ push, remove, form }) => {
                    const teachingRequirements =
                      form.values.teachingRequirements;
                    return (
                      <Box>
                        <Button
                          colorScheme="blue"
                          mb={6}
                          variant="outline"
                          leftIcon={<AddIcon />}
                          onClick={() => push("")}
                        >
                          Add requirement
                        </Button>

                        <Stack>
                          {teachingRequirements.map((req, index) => (
                            <HStack
                              spacing={4}
                              key={`${index}_${teachingRequirements.length}`}
                            >
                              <Input
                                flex="1"
                                borderColor="neutral.500"
                                defaultValue={
                                  form.values.teachingRequirements[index]
                                }
                                placeholder="Type a requirement"
                                onChange={({ target }) => {
                                  form.setFieldValue(
                                    `teachingRequirements[${index}]`,
                                    target.value,
                                  );
                                }}
                              />

                              <Icon
                                as={DeleteIcon}
                                cursor="pointer"
                                color="red.500"
                                onClick={() => remove(index)}
                                aria-label="Delete requirement"
                              />
                            </HStack>
                          ))}
                        </Stack>
                      </Box>
                    );
                  }}
                </FieldArray>
              </Box>

              <SingleFormButton
                nextText="Save requirements"
                isLoading={isLoading}
                onNextClick={handleSubmit}
              />
            </Form>
          </Box>
        )}
      </Formik>
    );
  },
);

export default RequirementsForm;
